import axios from "axios";

export function getProjectList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Project/getlist", config);
}

export function postProject(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(process.env.VUE_APP_API_URL + "Project/add", data, config);
}

export function updateProject(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.put(process.env.VUE_APP_API_URL + "Project/update", data, config);
}

export function deleteProject(projectId) {
  const config = {
    params: {
      projectId: projectId,
    },
  };
  return axios.delete(process.env.VUE_APP_API_URL + "Project/delete", config);
}
